import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ErrorHandlerService } from './pipe.service';
import { environment } from 'src/enviroment/environment';

@Injectable({
  providedIn: 'root',
})
export class SuperadminService {
  constructor(private http: HttpClient, private errorHandler: ErrorHandlerService) {}

  // Login with existing superadmin credentials
  loginSuperadminWithExisting(credentials: { email: string, password: string }): Observable<any> {
    return this.http.post<any>(environment.serverUrl + '/api/superadmin/login', credentials).pipe(
      this.errorHandler.handleError()
    );
  }

  // Sign up as a new superadmin
  signUpAsSuperadmin(details: { email: string, password: string }): Observable<any> {
    return this.http.post<any>(environment.serverUrl + '/api/superadmin/signup', details).pipe(
      this.errorHandler.handleError()
    );
  }

  // Fetch packages
  getPackages(): Observable<any> {
    return this.http.get<any>(environment.serverUrl + '/api/packages').pipe(
      this.errorHandler.handleError()
    );
  }

  // Fetch tests
  getTests(): Observable<any> {
    return this.http.get<any>(environment.serverUrl + '/api/tests').pipe(
      this.errorHandler.handleError()
    );
  }

  // Fetch mappings
  getMappings(): Observable<any> {
    return this.http.get<any>(environment.serverUrl + '/api/org/allWithPackages').pipe(
      this.errorHandler.handleError()
    );
  }

  // Create a package
  createPackage(packageData: any): Observable<any> {
    return this.http.post<any>(environment.serverUrl + '/api/packages', packageData).pipe(
      this.errorHandler.handleError()
    );
  }

  // Create a test
  createTest(testData: any): Observable<any> {
    return this.http.post<any>(environment.serverUrl + '/api/tests', testData).pipe(
      this.errorHandler.handleError()
    );
  }

  // Create a mapping
  createMapping(mappingData: any): Observable<any> {
    return this.http.post<any>(environment.serverUrl + '/api/org/mapTestPackages', mappingData).pipe(
      this.errorHandler.handleError()
    );
  }
}